import React from 'react';
import PropTypes from 'prop-types';

import AbelModal from '../../Components/Modal';
import Loading from '../../Components/Loading';
import PageText from '../../Components/Text/PageText';

class ExpiredLogout extends React.Component {
    render() {
        var { BottomButton, BottomButtonDisabled, BottomButtonOnClick, BottomButtonRender, BottomButtonText, className, DisplayNone, Information, InformationRenderer, NoMargin, OnHide, Show, Size, TextAlign } = this.props;

        if (!!BottomButtonRender) { BottomButton = null; BottomButtonDisabled = null; BottomButtonOnClick = null; BottomButtonText = null; }

        return (
            <AbelModal
                className={className}
                BottomButton={BottomButton || null}
                BottomButtonOnClick={BottomButtonOnClick}
                BottomButtonRender={BottomButtonRender}
                BottomButtonText={BottomButtonText}
                Disabled={BottomButtonDisabled}
                DisplayNone={DisplayNone}
                NoMargin={NoMargin}
                Show={Show}
                Size={Size || "large"}
                OnHide={OnHide}
                TopButton={null}
            >
                {this.props.Loading ? <Loading /> : null}

                {
                    InformationRenderer ?
                    InformationRenderer()
                :
                    <PageText FontFamily="medium" FontSize="medium-2" NoMargin Text={Information} TextAlign={TextAlign || 'center'} />
                }
            </AbelModal>
        );
    }
}

ExpiredLogout.propTypes = {
    BottomButton: PropTypes.string,
    BottomButtonDisabled: PropTypes.bool,
    BottomButtonOnClick: PropTypes.func,
    BottomButtonRender: PropTypes.func,
    BottomButtonText: PropTypes.string,
    DisplayNone: PropTypes.bool,
    Information: PropTypes.string,
    InformationRenderer: PropTypes.func,
    Loading: PropTypes.bool,
    NoMargin: PropTypes.bool,
    OnHide: PropTypes.func.isRequired,
    Show: PropTypes.bool.isRequired,
    Size: PropTypes.string,
    TextAlign: PropTypes.string
}

export default ExpiredLogout;